import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="alert alert-error">
          <h3>Something went wrong</h3>
          <p>Try refreshing the page</p>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;